import { format, parse } from 'date-fns';

import { Provider } from '@src/lib/__generated/sdk';

export const getProviderHeroTitle = ({ firstName, lastName, middleName, degreeName }: Provider) => {
	const updatedMiddleName = middleName ? `${middleName.charAt(0)}. ` : '';
	const updatedDegree = degreeName ? `, ${degreeName}` : '';
	return `Dr. ${firstName ?? ''} ${updatedMiddleName}${lastName ?? ''}${updatedDegree}`;
};

export const getProviderAboutTitle = ({ firstName, lastName }: Provider) => {
	return `About Dr. ${firstName ?? ''} ${lastName ?? ''}`;
};

export const getProviderAboutSubTitleList = (provider: Provider, config: BrandThemeConfig) => {
	return [
		{
			value: provider.mainWorkerFunction ? provider.mainWorkerFunction : '',
		},
		{
			value: provider.degreeName ? provider.degreeName : '',
		},
		{
			value: provider.stateLicense ? provider.stateLicense : '',
		},
		{
			value:
				provider.workerType && provider.workerType !== 'Employee'
					? provider.workerType === 'Contingent Worker'
						? `Independent Contractor at ${config.name}`
						: provider.workerType
					: '',
		},
	];
};

export const getProviderOfficesTitle = ({ lastName }: Provider) => {
	return `Offices associated with Dr. ${lastName ?? ''}`;
};

export const getProviderEducationDetails = (provider: Provider) => {
	return provider.collegeName ? `${provider.collegeName}, ${provider.degreeName}` : undefined;
};

export const getProviderLanguages = (provider: Provider) => {
	return provider.languages && provider.languages.length > 0 ? provider.languages.join(', ') : undefined;
};

export const getProviderHireDate = (provider: Provider) => {
	if (!provider.hireDate) return undefined;

	// Extract the date portion only (YYYY-MM-DD)
	const dateOnly = provider.hireDate.split('T')[0];

	const date = parse(dateOnly, 'yyyy-MM-dd', new Date());

	return format(date, 'MMMM yyyy');
};
